// user test recording currently relies on element ids.
// Ideally we'd fix this to use refs
export var CURRENT_SCREEN_ID = 'currentScreen';
export var PREVIOUS_SCREEN_ID = 'prevScreen';
export var CURRENT_OVERLAY_ID = 'currentOverlay';
export var SCREEN_LAYER = 'screen';
export var OVERLAY_LAYER = 'overlay';
export var SCROLL_CONTAINER_LAYER = 'scrollContainer';
